import styled from 'styled-components';
import { maxDesktop } from '../../styles/variables';

export const Wrapper = styled.div`
    display: flex;
    max-width: ${maxDesktop};
    margin: 0 auto;
    height: 80vh;
    padding: 5px;
`;
